import React, { useState, useEffect, useContext } from "react";
// External Compnents
import Axios from "axios"; // Axios for api calling
import { Button } from "@material-ui/core"; //Material Ui
import { withTranslation, useTranslation, Trans } from 'react-i18next'  //Localization

// Internal Components
import Page from "./Page";
import LoaderAnimation from "./LoaderAnimation"; 
import StateContext from "../StateContext";
// Cookies Function
import { setCookie } from "../Functions/cookieFunction"
import { handleError } from "../Functions/getAlert";
import DispatchContext from "../DispatchContext";


function NoOrders() {
  const {t} = useTranslation();
  const appState = useContext(StateContext);
  return (
    <>
      <div className="empBox">
        <div className="text-center py-5">
          {/* BoxImg */}
          <div className="BoxImg">
            <img
              src={`${process.env.REACT_APP_IMAGE_URL}box.png`}
              alt=""
              className="img-fluid"
            />
          </div>
          <div className="mt-1">
            <p className="text-secondary">
              <strong>{t("status.order-not-found")}</strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

function AllOrders(props) {
  let newDate = [];
  for (let i = 0; i < props.allOrders.length; i++) {
    let splitDate = props.allOrders[i].created_at;
    newDate.push(splitDate);
  }
  const date_result = [];
  const map = new Map();
  for (const item of newDate) {
    if (!map.has(item)) {
      map.set(item, true); // set any value to Map
      date_result.push({
        date: item,
      });
    }
  }
  const [Date_Result, setDate_Reslt] = useState(date_result);
  return (
    <>
      {/* data-content__dashboard */}
      <div className="data-content__dashboard">
        {/* data-row__dashboard */}
        <div className="data-row__dashboard">
          {/* {Date_Result.map(newDate =>  */}
          <DateWiseOrders allOrders={props.allOrders} date={newDate.date} />
        </div>
      </div>
    </>
  );
}

function DateWiseOrders(props) {
  const allOrders = props.allOrders;
 const [seeMore, setSeeMore] =  useState(5) 
  const handleSeeMore = () => {
    let count = seeMore + 5
  if(count < allOrders.length ){
    setSeeMore(count)
  }else if(count > allOrders.length ){
    setSeeMore(allOrders.length)
  }
}
const getReOrder = (value) =>{
  setCookie("Re-Order", value.invoice_id);
  setCookie("Add-to-Cart", JSON.stringify(value.orders));

 const win = window.open(`${process.env.REACT_APP_SHOP_URL+value.store.slug}`, "_blank");
  win.focus();
}


  return (
    <>
      <div className="date text-secondary">{props.date}</div>
      {/* data-row */}
      <div className="row m-0 d-flex justify-content-center">
        {
          allOrders.slice(0, seeMore).map((newOrder) => (
            <React.Fragment>

            <div className="col-md-8 ordersList">
              <a href={`/invoice/in/${newOrder.invoice_id}`}>
                <DataRow orderDetails={newOrder} key={newOrder.id} />
              </a>
            </div>
              {/* <button style={{backgroundColor: 'transparent', borderStyle: 'none', borderRadius: 'none'}} 
                    onClick={() => getReOrder(newOrder)}>Re-Order</button> */}
            </React.Fragment>

          ))
          // .filter(order => order.issue_date.split(" ")[0].includes(props.date))
        }
      </div>
      <div className="col-12 d-flex justify-content-center mb-2">
          { seeMore < allOrders.length ?  <Button
              variant="text"
              onClick={handleSeeMore}
              className={`seeMoreBtn`}
            >
              {" "}{"See More"}{" "}
            </Button>
            : ""
}            </div>

    </>
  );
}
function DataRow(props) {
  const appState = useContext(StateContext);
  let Time = props.orderDetails.created_at;
  const { t } = useTranslation();

  return (
    <>
      <div className="data-row" id={"order-" + props.orderDetails.id}>
        <div className="row m-0 align-items-center justify-content-center text-center">
          <div className="col-4 text-left px-1">
            {/* <div className="data-row__title">#{props.data_id}</div> */}
            <div className="row m-0 align-items-center">
              <div className="brandLogo" style={{ width: "60px" }}>
                <img
                  src={props.orderDetails.store.logo}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="text pl-2">
                {/* <p className="text-muted m-0 small">Mall based store</p> */}
                <h6 className="m-0">{props.orderDetails.store.name}</h6>
              </div>
            </div>
          </div>

          <div className="col-4 text-center p-0">
            <div className="data-row__payment_method_time">
              <div className="row m-0 justify-content-center align-items-center">
                <div className="row m-0 text-left align-items-center justify-content-center text-center">
                  <div className="payment_method_icon">
                    <img
                      src={`${process.env.REACT_APP_IMAGE_URL}calendar.png`}
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                  <div>
                    <p  className="small text-muted m-0 text-uppercase">
                    {t("dashboard.processed-on")}
                    </p>
                    <p className="time m-0">
                      <strong>{Time}</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div  className="col-4 text-right p-0">
            <div className="data-row__price">
              <h5 >
                <strong>
                  {parseFloat(
                    props.orderDetails.total_after_discount
                      ? props.orderDetails.total_after_discount
                      : "0"
                  ).toFixed(3)}{" "}
                  {t("KWD")}
                </strong>
              </h5>
              <div>
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}${
                    props.orderDetails.order_invoice
                      ? props.orderDetails.order_invoice.payment_service_id ===
                        1
                        ? "knet"
                        : props.orderDetails.order_invoice
                            .payment_service_id === 2
                        ? "credit"
                        : props.orderDetails.payment_service_id === 3
                        ? "wallet"
                        : props.orderDetails.order_invoice
                            .payment_service_id === 4
                        ? "cash"
                        : ""
                      : ""
                  }.png`}
                  className="img-fluid"
                  width="30"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*  */}

    
    </>
  );
}

function Orders(props) {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext)
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_API_URL}customer/invoice`,
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );
        
        setOrders(response.data.data.reverse()); 

        props.setCount(response.data.data.length);

        setIsLoading(false);
      } catch (e) {
      handleError(e, appDispatch)
        Promise.reject(e);
      }
    };
    fetchData();
  }, []);
  if (isLoading)
    return (
      <div style={{ position: "relative", height: "250px" }}>
          {/* <CircularProgress /> */}
              <LoaderAnimation />
      </div>
    );
  if (orders.length > 0) {
    return (
      <Page title="Orders">
        <AllOrders allOrders={orders} />
      </Page>
    );
  } else {
    return (
      
      <Page title="Orders">
        <NoOrders />
      </Page>
    );
  }
}

export default withTranslation() (Orders);
